import { useOpenModal } from './useOpenModal'
import { AppGuide } from 'featureSliced/widgets/AppGuide'

export const useOpenAppGuideModal = () => {
  const openModal = useOpenModal()

  const openAppGuideModal = () => {
    openModal({
      id: 'GUIDE_MODAL',
      components: [() => <AppGuide />],
    })
  }
  return openAppGuideModal
}
